import { render, staticRenderFns } from "./TranslationTooltip.vue?vue&type=template&id=0e7c44ad&scoped=true&"
import script from "./TranslationTooltip.vue?vue&type=script&lang=js&"
export * from "./TranslationTooltip.vue?vue&type=script&lang=js&"
import style0 from "./TranslationTooltip.vue?vue&type=style&index=0&id=0e7c44ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7c44ad",
  null
  
)

export default component.exports